import Vue from "vue";
import Router from "vue-router";
import wx from 'weixin-js-sdk';
Vue.use(Router);

import index from '@/pages/index/index.vue';//首页
import info from '@/pages/info/index.vue';//信息填写页
import answer from '@/pages/answer/index.vue';//答题部分
import Identity from '@/pages/Identity/index.vue';//答题部分
import counter from '@/pages/counter/index.vue';//答题部分
import luckDraw from '@/pages/luckDraw/index.vue';//答题部分
var router =  new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      alias: '/pages/index/main'
    },
    {
      path: '/info',
      name: 'info',
      component: info,
      alias: '/pages/info/main'
    },
    {
      path: '/answer',
      name: 'answer',
      component: answer,
      alias: '/pages/answer/main'
    },
    {
      path: '/Identity',
      name: 'Identity',
      component: Identity,
      alias: '/pages/Identity/main'
    },
    {
      path: '/counter',
      name: 'counter',
      component: counter,
      alias: '/pages/counter/main'
    },
    {
      path: '/luckDraw',
      name: 'luckDraw',
      component: luckDraw,
      alias: '/pages/luckDraw/main'
    },
  ]
})

router.beforeEach((to, from, next) => {
  // console.log(to.fullPath,88888)
  var fullPath = to.fullPath;
  if(fullPath.indexOf("answer")==-1){
    let share_url = window.location.href
    // http://wechat.jrmb.kuaichuangkeji.com/#/
    // console.log(url,999)
    let asanFn = async()=>{
      let jssdkArr = await Vue.prototype.$http.get(`https://apidgybwj.kuaichuangkeji.com/wechat/share`,{
        url:share_url,
      })
      // console.log(jssdkArr,"jddsk")
      if(jssdkArr){
        let res = jssdkArr;
        const shareTitle = "东莞医保服务满意度调查活动";
        const shareURL = 'http://wechat.dgybwj.kuaichuangkeji.com';
        const shareDesc = "快来参与“东莞医保服务满意度调查活动”，领取微信红包!";
        // const shareURL = res.url;
        wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
                'checkJsApi',
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'onMenuShareQQ',
                'onMenuShareWeibo',
                'hideMenuItems',
                'showMenuItems',
                'hideAllNonBaseMenuItem',
                'showAllNonBaseMenuItem'
            ]
        })
        wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
        // 分享朋友
            wx.onMenuShareAppMessage({ 
                title: shareTitle, // 分享标题
                desc: shareDesc, // 分享描述
                link: shareURL, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: 'http://wechat.dgybwj.kuaichuangkeji.com/static/img/weix.png', // 分享图标
                success: function() {
                    alert("分享成功")
                },
                cancel: function() {
                    alert("您取消了分享!")
                }
            }); 
        //分享朋友圈
            wx.onMenuShareTimeline({ 
                title: shareTitle, // 分享标题
                desc: shareDesc, // 分享描述
                link: shareURL, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: 'http://wechat.dgybwj.kuaichuangkeji.com/static/img/weix.png', // 分享图标
                success: function() {
                    alert("分享成功")
                },
                cancel: function() {
                    alert("您取消了分享")
                }
            }); 
        });
      }
    }
    asanFn();
  }
  next()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js